import React from 'react';
import { User as UserIcon } from 'lucide-react';
import { clsx } from 'clsx';

interface UserAvatarProps {
  photoUrl?: string;
  name?: string;
  className?: string;
}

export const UserAvatar: React.FC<UserAvatarProps> = ({ photoUrl, name, className }) => {
  if (photoUrl) {
    return (
      <img 
        src={photoUrl} 
        alt={name} 
        className={clsx("rounded-sm border border-primary/20", className)} 
      />
    );
  }

  return (
    <div className={clsx(
      "rounded-sm border border-primary/40 bg-primary/10 flex items-center justify-center text-primary rust-glow",
      className
    )}>
      <UserIcon size={18} />
    </div>
  );
};
